/** @jsxImportSource @emotion/react */

import { InputGroup } from "@blueprintjs/core"
import { useField, useFormikContext } from "formik"
import { useEffect, useState } from "react"
import InstrumentSuggest from "../../../components/InstrumentSuggest"
import { InstrumentLight } from "../../Config/types"
import { IdeaPosition, IdeaStock } from "../types/business"
import { IIdeaCreateForm } from "./IdeaCreate"
import { tradeOpenInputCss } from "./StockField.styled"

export interface IStockFieldProps {
  ideaPosition: IdeaPosition
  initialSelectedValue?: Partial<IdeaStock>
  isTradeOpen: boolean
}

const StockField = ({ ideaPosition, initialSelectedValue, isTradeOpen }: IStockFieldProps) => {
  const [idField] = useField(`trade.${ideaPosition}.instance.id`)
  const [bloombergCodeField] = useField(`trade.${ideaPosition}.instance.bloomberg_code`)
  const { setFieldValue } = useFormikContext<Partial<IIdeaCreateForm>>()

  const [selectedInstrument, setSelectedInstrument] = useState<InstrumentLight | null>(null)

  /**
   * Set initial value if provided
   */
  useEffect(() => {
    if (initialSelectedValue?.id) {
      setFieldValue(idField.name, initialSelectedValue.id)
      setFieldValue(bloombergCodeField.name, initialSelectedValue.bloomberg_code)
    }
  }, [idField.name, bloombergCodeField.name, setFieldValue, initialSelectedValue])

  const handleInstrumentSelect = (instrument: InstrumentLight) => {
    setSelectedInstrument(instrument)
    setFieldValue(idField.name, instrument.id)
    setFieldValue(bloombergCodeField.name, instrument.bloomberg_code)
  }

  return (
    <>
      {isTradeOpen ? (
        <InputGroup
          defaultValue={initialSelectedValue?.bloomberg_code}
          readOnly={true}
          large
          css={tradeOpenInputCss}
          style={isTradeOpen ? { pointerEvents: "none" } : undefined}
        />
      ) : (
        <InstrumentSuggest
          selectedInstrument={selectedInstrument}
          onInstrumentSelect={handleInstrumentSelect}
          placeholder="Search for instrument"
        />
      )}
    </>
  )
}

export default StockField
